import { createReducer, on } from "@ngrx/store";
import { EventStoreModel } from "../models/events.models";
import { EventApiActions } from "../actions/events.actions";
import { eventAdapter } from "../adapters/events.adapter";


export const initialState: EventStoreModel = {
    allUpcoming: false,
    events: eventAdapter.getInitialState()
}

export const eventsReducer = createReducer(
    initialState,
    on(EventApiActions.fetchAllEventsBySystem, (state, { events, systemRef }) => ({
        ...state,
        events: eventAdapter.setAll(events,state.events)
    })),
    on(EventApiActions.fetchAllUpcomingEvents, (state, { events }) => ({
        events: eventAdapter.setAll(events,state.events),
        allUpcoming: true
    })),
    on(EventApiActions.fetchSingleEvent, (state, { event }) => ({
        ...state,
        events: eventAdapter.upsertOne(event,state.events)
    })),
    on(EventApiActions.fetchedAttendees, (state, { update }) => ({
        ...state,
        events: eventAdapter.updateOne(update,state.events)
    }))
)